import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faSitemap, faInfo, faSquarePlus, faSquareMinus, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Outlet } from 'react-router';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import '../style/myContent.css';
import { useMyContentContext } from '../utils/myContentContext';

const myContentNav = [
  {
    id: 1,
    name: 'Question Sets',
    path: 'questionsets',
    comingSoon: false,
    hidden: false
  },
  {
    id: 2,
    name: 'Flash Card Sets',
    path: 'flashcardssets',
    comingSoon: true,
    hidden: true
  },
  {
    id: 3,
    name: 'Resource Sets',
    path: 'resourcesets',
    comingSoon: false,
    hidden: false
  },
  {
    id: 4,
    name: 'Study Sets',
    path: 'studysets',
    comingSoon: true,
    hidden: true
  }
];

const Index = () => {
  const { setActiveTab, setSelectedSets } = useMyContentContext();
  const [displayInstruction, setDisplayInstruction] = useState(false);

  const conditionalRenderingData = () => {
    const url = window.location.href;
    const endString = url.substr(url.lastIndexOf('/') + 1);
    switch (endString) {
      case 'questionsets':
        setActiveTab('questionsets');
        break;
      case 'resourcesets':
        setActiveTab('resourcesets');
        break;
      default:
        setActiveTab('questionsets');
    }
  };

  useEffect(() => {
    conditionalRenderingData();
  }, []);

  return (
    <>
      <div className='white-card mb-5'>
        <div className='d-flex'>
          <h1>My Content</h1>
          <div>
            <div className='lockdown-tooltip-text'>
              <FontAwesomeIcon id="clickableTooltip" className="circle-question ms-2" icon={faCircleQuestion} />
            </div>
            <ReactTooltip anchorSelect="#clickableTooltip" clickable className='z-index10 mycontent-title-tooltip' place="right">
              <p className=' text-white'>Use caution when modifying or deleting content from a Personal Content Set. If in use by an assignment, the content in the assignment is also modified or deleted.</p>
              <Row>
                <Col>
                  <FontAwesomeIcon icon={faCircleInfo} />
                  <span>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://cl.castlelearning.com/review/Documents/ExplainingtheNewAssessmentFeature.pdf"
                      className="text-decoration-underline p-1 text-white">
                      Assessment  Overview
                    </a>
                  </span>
                </Col>
                <Col>
                  <FontAwesomeIcon className='ml-3' icon={faSitemap} />
                  <span>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://cl.castlelearning.com/review/Documents/Personal%20Content%20Sets-Assessment%20Sets.pdf"
                      className="text-decoration-underline p-1 text-white">
                      Detailed Steps
                    </a>
                  </span>
                </Col>
              </Row>
            </ReactTooltip>
          </div>
          <div className='align-items-center cursor-pointer fw-500 ms-auto text-instruction' onClick={() => setDisplayInstruction(!displayInstruction)}>
            Instructions<FontAwesomeIcon className='fs-6 ms-2' icon={displayInstruction ? faSquareMinus : faSquarePlus} />
          </div>
        </div>
        {displayInstruction && (
          <div className='justify-text border-grey mt-3' id="instruction">
            <p>
              Personal Content/Assessment Sets consist of either questions, flash cards, documents, URL&apos;s as well as audio and video files. Click the Set Name to view or modify a set. When adding questions you can create your own or include Castle questions. When including Castle questions you will have the option to <strong>duplicate and edit</strong> those questions. In that case they become your own questions and are not linked back to the original Castle question. To include your content in assignments, use the <strong>Personal Content Sets tab</strong> on the <strong>Add Questions</strong> page. To transfer your sets to an administrator or another teacher use the <strong>Transfer to Administrator/Teacher</strong> options for the set.
            </p>
          </div>
        )}

        <div className='primary-tab'>
          <div className='btn-group mt-3'>
            {myContentNav.map((item, index) => {
              if (item.hidden) return;
              return (
                <>
                  {item.comingSoon ? (
                    <OverlayTrigger
                      key={`myContentTab-${index}`}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-${index}`} className='custom-tooltip'>
                          <p className='mb-0'>Coming Soon!</p>
                        </Tooltip>
                      }>
                      <a key={item.id} className='btn' to={item.path} disabled={true}>
                        {item.name}
                      </a>
                    </OverlayTrigger>
                  ) : (
                    <NavLink
                      key={item.id}
                      className='btn rounded'
                      onClick={() => { setActiveTab(item.path); setSelectedSets([]); }}
                      to={item.path}>
                      {item.name}
                    </NavLink>
                  )}
                </>
              )
            })}
          </div>
        </div>
        <Outlet />
      </div>
      <div className='info-text d-flex mb-5'>
        <div>
          <span>
            <FontAwesomeIcon icon={faInfo} />
          </span>
        </div>
        <div className='text-justify'>
          <p>
            You should not use copyrighted material in your Personal Content/Assessment Sets. If you use or share content that contain copyrighted content, you may be violating state and federal copyright laws. You - and not CASTLE Software, Inc. - are responsible for such copyright infringement violations.
          </p>
          <p className='mt-3'>
            In the event a claim is made against Castle Software, Inc. by virtue of your acts or commission and/or omission, you agree to Indemnify and hold harmless Castle Software, Inc. including, but not limited to, any judgment, court costs and expenses.
          </p>
        </div>
      </div>
    </>
  );
};

export default Index;